"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entityEmptyRule = void 0;
exports.isEntityEmpty = isEntityEmpty;
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
const ruleId = 'entity-empty';
const ruleName = 'empty entity';
const ruleDescription = 'entities with 0 rows or 0 bytes';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.EntityId.array().optional(),
}).strict().describe('EntityEmptyConf');
exports.entityEmptyRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.low },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.entity).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.entityRefFromId) || []);
        return (db.entities || [])
            .filter(e => isEntityEmpty(e))
            .filter(e => !ignores.some(i => (0, databaseUtils_1.entityRefSame)(i, (0, databaseUtils_1.entityToRef)(e))))
            .map(e => ({
            ruleId,
            ruleName,
            ruleLevel: conf.level,
            message: `Entity ${(0, databaseUtils_1.entityToId)(e)} is empty.`,
            entity: (0, databaseUtils_1.entityToRef)(e),
        }));
    }
};
function isEntityEmpty(entity) {
    return (entity.stats?.rows !== undefined ? entity.stats.rows === 0 : false) || (entity.stats?.size !== undefined ? entity.stats.size === 0 : false);
}
//# sourceMappingURL=entityEmpty.js.map